import React from 'react';
import { MgmntSignDocCard } from '../SignDoc/MgmntSignDocCard/MgmntSignDocCard';
import { i18n } from '../../Utils/i18n/i18n';
import Tooltip from '@mui/material/Tooltip';
import './PathDocumentItem.scss';
import ClearIcon from '@mui/icons-material/Clear';


/**
 * A component that renders a document item within a learning path sequence.
 * 
 * @component
 * @param {Object} props - Component props
 * @param {Object} props.document - The document object to be displayed
 * @param {Function} props.onRemove - Callback function triggered when document is removed from path
 * @returns {JSX.Element} Rendered PathDocumentItem component
 */
export const PathDocumentItem = ({ 
    document, 
    onRemove, 
}) => {

    const handleRemove = () => {
        onRemove({documentId: document.id});
    };

    return (
        <div className="PathDocumentItem" id={`path-document-${document.id}`}>
            <div className="documentCard">
                <div className="cardWithRemoveButton">
                    <MgmntSignDocCard 
                        signDoc={document} 
                        noButton={true}
                    />
                    <Tooltip title={i18n.translate('learningPath.removeFromPath') || "Remove from learning path"} placement="top">
                        <div className="removeButton" onClick={handleRemove}>
                            <ClearIcon />
                        </div>
                    </Tooltip>
                </div>
            </div>
        </div>
    );
};